/* Noa selector only. Shopify remains the source of cart and checkout prices.
 * No submit handler and no cart mutation here: theme.AjaxProduct calls prepare.
 */
(function(root) {
  'use strict';
  var totals = {1: 2995, 2: 4995, 3: 5995};
  var states = new WeakMap();

  function money(cents) { return (cents / 100).toFixed(2).replace('.', ',') + ' €'; }
  function error(message) { return {responseJSON: {description: message}}; }
  function lookup(variants, id) {
    return variants.find(function(variant) { return String(variant.id) === String(id); });
  }
  function limit(variant) {
    var maximum = Infinity;
    if (!variant || !variant.available) return 0;
    if (variant.inventoryManagement && variant.inventoryPolicy !== 'continue') {
      // Missing tracked-stock data is never treated as unlimited inventory.
      maximum = Number.isFinite(variant.inventoryQuantity) ? Math.max(0, variant.inventoryQuantity) : 0;
    }
    var rule = variant.quantityRule || {};
    if (rule.max !== null && rule.max !== undefined && Number.isFinite(Number(rule.max))) {
      maximum = Math.min(maximum, Number(rule.max));
    }
    return maximum;
  }
  function buildItems(selections, quantity) {
    if (!Number.isInteger(quantity) || quantity < 1 || quantity > 3) {
      throw error('Elige una oferta de 1, 2 o 3 bolsos.');
    }
    var counts = new Map();
    selections.slice(0, quantity).forEach(function(id) {
      if (!id) throw error('Selecciona un color disponible para cada bolso.');
      id = String(id);
      counts.set(id, (counts.get(id) || 0) + 1);
    });
    if (selections.length < quantity) throw error('Selecciona un color para cada bolso.');
    return Array.from(counts, function(entry) { return {id: entry[0], quantity: entry[1]}; });
  }
  function validateStock(variants, items, cart) {
    items.forEach(function(item) {
      var variant = lookup(variants, item.id);
      if (!variant || !variant.available) {
        throw error(variant ? 'El color ' + variant.title + ' está agotado. Elige otro color.' : 'Selecciona un color disponible.');
      }
      var alreadyInCart = ((cart && cart.items) || []).reduce(function(total, line) {
        return total + (String(line.variant_id || line.id) === String(item.id) ? Number(line.quantity) : 0);
      }, 0);
      var requested = item.quantity + alreadyInCart;
      if (requested > limit(variant)) {
        throw error('No hay suficientes unidades de ' + variant.title + ' para esta selección, incluyendo las de tu carrito. Elige otro color o reduce la cantidad.');
      }
      var rule = variant.quantityRule || {};
      if (requested < Number(rule.min || 1) || requested % Number(rule.increment || 1) !== 0) {
        throw error('Revisa la cantidad disponible para el color ' + variant.title + '.');
      }
    });
    return true;
  }
  function showError(form, message) {
    var output = form && form.querySelector('[data-noa-error]');
    if (!output) return;
    output.textContent = message || 'No se pudo añadir al carrito. Inténtalo de nuevo.';
    output.hidden = false;
    output.focus({preventScroll: true});
  }
  function clearError(state) {
    var output = state.bundle.querySelector('[data-noa-error]');
    output.textContent = '';
    output.hidden = true;
  }
  function canChoose(state, id, slot) {
    var sameElsewhere = state.selections.slice(0, state.quantity).reduce(function(count, selected, index) {
      return count + (index !== slot && String(selected) === String(id) ? 1 : 0);
    }, 0);
    return sameElsewhere + 1 <= limit(lookup(state.config.variants, id));
  }
  function reconcile(state) {
    var chosen = [];
    for (var slot = 0; slot < state.quantity; slot++) {
      var candidate = lookup(state.config.variants, state.selections[slot]);
      function hasRoom(variant) {
        var used = chosen.filter(function(id) { return String(id) === String(variant.id); }).length;
        return used < limit(variant);
      }
      if (!candidate || !hasRoom(candidate)) candidate = state.config.variants.find(hasRoom);
      state.selections[slot] = candidate ? String(candidate.id) : '';
      chosen.push(state.selections[slot]);
    }
  }
  function update(state) {
    state.bundle.toggleAttribute('data-noa-pending', !!state.pending);
    state.bundle.querySelectorAll('[data-noa-tier]').forEach(function(input) {
      input.checked = Number(input.value) === state.quantity;
      input.disabled = !!state.pending;
    });
    state.bundle.querySelectorAll('[data-noa-slot]').forEach(function(fieldset, slot) {
      fieldset.hidden = slot >= state.quantity;
      var variant = lookup(state.config.variants, state.selections[slot]);
      fieldset.querySelector('[data-noa-color-name]').textContent = variant ? variant.title : 'Elige un color disponible';
      fieldset.querySelectorAll('[data-noa-variant]').forEach(function(input) {
        input.checked = String(input.value) === state.selections[slot];
        input.disabled = !!state.pending || slot >= state.quantity || !canChoose(state, input.value, slot);
      });
    });
    state.bundle.querySelector('[data-noa-summary]').textContent = state.quantity +
      (state.quantity === 1 ? ' bolso' : ' bolsos') + ' · Total ' + money(totals[state.quantity]);
  }
  function syncNative(state, id) {
    var variant = lookup(state.config.variants, id);
    if (!variant) return;
    var changed = null;
    var native = state.form.querySelector('[data-vera-noa-native]');
    if (native) {
      variant.options.forEach(function(value, index) {
        native.querySelectorAll('input[data-index="option' + (index + 1) + '"]').forEach(function(input) {
          if (input.type !== 'radio') return;
          var checked = input.value === value;
          if (input.checked !== checked && checked) changed = input;
          input.checked = checked;
        });
        native.querySelectorAll('select[data-index="option' + (index + 1) + '"]').forEach(function(select) {
          if (select.value !== value) changed = select;
          select.value = value;
        });
      });
    }
    var master = state.form.querySelector('select[name="id"]');
    if (master) master.value = String(variant.id);
    if (changed) {
      var beforeVariantChange = new URL(root.location.href);
      var addToCart = state.form.querySelector('.add-to-cart');
      var addToCartText = addToCart && addToCart.querySelector('[id^="AddToCartText-"]');
      if (!state.addToCartLabel && addToCartText && !addToCart.disabled) {
        state.addToCartLabel = addToCartText.textContent.trim();
      }
      // Trigger the theme's one original variant pipeline (gallery, price, SKU).
      if (root.jQuery) root.jQuery(changed).trigger('change');
      else changed.dispatchEvent(new Event('change', {bubbles: true}));
      // Keep the PDP's configured CTA copy: the native event otherwise resets
      // it to the theme locale string even when only the color has changed.
      if (variant.available && addToCartText && !addToCart.disabled && state.addToCartLabel) {
        addToCartText.textContent = state.addToCartLabel;
      }
      // This theme rebuilds the URL as pathname + ?variant=, which discards the
      // alternate template in a preview. Restore only its rendering parameters
      // after the native synchronous event, retaining the selected variant.
      if (beforeVariantChange.searchParams.get('view') === 'noa-bundle' && root.history.replaceState) {
        var afterVariantChange = new URL(root.location.href);
        if (afterVariantChange.pathname === beforeVariantChange.pathname) {
          ['view', 'preview_theme_id'].forEach(function(key) {
            if (beforeVariantChange.searchParams.has(key)) {
              afterVariantChange.searchParams.set(key, beforeVariantChange.searchParams.get(key));
            }
          });
          root.history.replaceState(root.history.state, '', afterVariantChange.toString());
        }
      }
    }
  }
  function initBundle(bundle) {
    if (states.has(bundle)) return states.get(bundle);
    var form = bundle.closest('form');
    if (!form) return null;
    var config;
    try { config = JSON.parse(bundle.querySelector('[data-noa-config]').textContent); }
    catch (_) { return null; }
    if (!config.variants || !config.variants.length) return null;
    var initial = lookup(config.variants, config.selectedId);
    if (!initial || !initial.available) initial = config.variants.find(function(variant) { return variant.available; });
    var initialId = initial ? String(initial.id) : '';
    var state = {bundle: bundle, form: form, config: config, quantity: 1, selections: [initialId, initialId, initialId], pending: false};
    states.set(bundle, state);
    reconcile(state);
    update(state);
    bundle.addEventListener('change', function(event) {
      if (state.pending) return;
      var input = event.target;
      if (input.matches('[data-noa-tier]')) {
        state.quantity = Number(input.value);
        reconcile(state);
        clearError(state);
        update(state);
      } else if (input.matches('[data-noa-variant]')) {
        var slot = Number(input.closest('[data-noa-slot]').dataset.noaSlot) - 1;
        if (!canChoose(state, input.value, slot)) return;
        state.selections[slot] = String(input.value);
        clearError(state);
        update(state);
        syncNative(state, input.value);
      }
    });
    form.querySelectorAll('[data-vera-noa-native]').forEach(function(native) { native.hidden = true; });
    bundle.hidden = false;
    return state;
  }
  function serialize(form, items) {
    var data = new FormData(form);
    var result = new URLSearchParams();
    var properties = [];
    var sellingPlan = data.get('selling_plan');
    data.forEach(function(value, key) {
      if (/^properties\[.+\]$/.test(key)) properties.push([key.slice(11, -1), value]);
      else if (key !== 'id' && key !== 'quantity' && key !== 'selling_plan' &&
               !/^items\[/.test(key) && !/^vera_noa_/.test(key) && typeof value === 'string') {
        result.append(key, value);
      }
    });
    items.forEach(function(item, index) {
      var prefix = 'items[' + index + ']';
      result.append(prefix + '[id]', item.id);
      result.append(prefix + '[quantity]', item.quantity);
      if (sellingPlan) result.append(prefix + '[selling_plan]', sellingPlan);
      properties.forEach(function(property) { result.append(prefix + '[properties][' + property[0] + ']', property[1]); });
    });
    return result.toString();
  }
  function prepare(form) {
    var bundle = form.querySelector('[data-vera-noa-bundle]');
    if (!bundle) return Promise.resolve(new URLSearchParams(new FormData(form)).toString());
    var state = initBundle(bundle);
    if (!state) return Promise.reject(error('No se pudo cargar la selección. Recarga la página e inténtalo de nuevo.'));
    clearError(state);
    var items;
    try {
      items = buildItems(state.selections, state.quantity);
    } catch (reason) { return Promise.reject(reason); }
    syncNative(state, state.selections[0]);
    // Capture the submission now, before async validation, with no hidden inputs
    // accumulating across tier changes or a second cart/add request.
    var serialized = serialize(form, items);
    state.pending = true;
    update(state);
    var routesRoot = (root.Shopify && root.Shopify.routes && root.Shopify.routes.root) || '/';
    return fetch(routesRoot + 'cart.js', {credentials: 'same-origin', cache: 'no-store', headers: {Accept: 'application/json'}})
      .then(function(response) {
        if (!response.ok) throw error('No se pudo comprobar el carrito. Inténtalo de nuevo.');
        return response.json();
      })
      .then(function(cart) {
        validateStock(state.config.variants, items, cart);
        return serialized;
      })
      .catch(function(reason) {
        throw reason && reason.responseJSON ? reason : error('No se pudo comprobar el carrito. Inténtalo de nuevo.');
      })
      .finally(function() { state.pending = false; update(state); });
  }
  function init(scope) {
    scope = scope || document;
    if (scope.matches && scope.matches('[data-vera-noa-bundle]')) initBundle(scope);
    scope.querySelectorAll('[data-vera-noa-bundle]').forEach(initBundle);
  }
  var api = {init: init, prepare: prepare, showError: showError, buildItems: buildItems, validateStock: validateStock, variantLimit: limit};
  root.VeraNoaBundle = api;
  if (typeof module !== 'undefined') module.exports = api;
  if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function() { init(); });
    else init();
    document.addEventListener('shopify:section:load', function(event) { init(event.target); });
  }
})(typeof window !== 'undefined' ? window : globalThis);
